import { render, staticRenderFns } from "./gaokaoZt.vue?vue&type=template&id=fd4569de&scoped=true"
import script from "./gaokaoZt.vue?vue&type=script&lang=js"
export * from "./gaokaoZt.vue?vue&type=script&lang=js"
import style0 from "./gaokaoZt.vue?vue&type=style&index=0&id=fd4569de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4569de",
  null
  
)

export default component.exports